/* eslint-disable jsx-a11y/prefer-tag-over-role */
const replaceEmojiWithSpan = (
  text: string,
  emoji: string,
  emojiName: string
): React.ReactNode => {
  // eslint-disable-next-line security/detect-non-literal-regexp
  const regex = new RegExp(`(${emoji})`, 'g');
  return (
    <>
      {text.split(regex).map((part, index) =>
        part === emoji ? (
          <span key={index} role="img" aria-label={emojiName}>
            {part}
          </span>
        ) : (
          part
        )
      )}
    </>
  );
};

const replaceEmojisWithSpan = (
  text: string,
  emojis: { emoji: string; emojiName: string }[] // Array de emojis y sus nombres
): React.ReactNode => {
  // Crear una expresión regular para todos los emojis
  const emojiRegex = new RegExp(
    `(${emojis.map(({ emoji }) => emoji).join('|')})`,
    'g'
  );

  return (
    <>
      {text.split(emojiRegex).map((part, index) => {
        const matchingEmoji = emojis.find(({ emoji }) => emoji === part);
        return matchingEmoji ? (
          <span key={index} role="img" aria-label={matchingEmoji.emojiName}>
            {matchingEmoji.emoji}
          </span>
        ) : (
          part
        );
      })}
    </>
  );
};

const upperCase = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

export { replaceEmojisWithSpan, replaceEmojiWithSpan, upperCase };
